import { render, staticRenderFns } from "./phone-recharge.vue?vue&type=template&id=286e8bc1&scoped=true&"
import script from "./phone-recharge.vue?vue&type=script&lang=js&"
export * from "./phone-recharge.vue?vue&type=script&lang=js&"
import style0 from "./phone-recharge.vue?vue&type=style&index=0&id=286e8bc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e8bc1",
  null
  
)

export default component.exports